<template>
  <div>
    <el-row>
      <el-col :span="6">
        <profile-locations-list
          @select-location="selectLocation"
          @refresh-list="refreshList"
          :items="chartItems"
          class="location-list"
        />
      </el-col>
      <el-col :span="18">
        <profile-locations-map
          ref="map"
          @update-data="updateData"
          :profile-id="profileId"
          :project-id="projectId"
          class="location-map"
        />
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <profile-locations-table :profile-id="profileId" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ProfileLocationsList from '@/modules/profiles/components/ProfileLocationsList'
import ProfileLocationsMap from '@/modules/profiles/components/ProfileLocationsMap'
import ProfileLocationsTable from '@/modules/profiles/components/ProfileLocationsListTable'

export default {
  name: 'ProfileLocationsPage',

  components: {
    ProfileLocationsList,
    ProfileLocationsMap,
    ProfileLocationsTable
  },

  data() {
    return {
      chart: {}
    }
  },

  props: {
    profileId: {
      required: true
    },

    projectId: {
      required: true
    }
  },

  computed: {
    chartItems() {
      return this.chart.data
    }
  },

  methods: {
    updateData(chart) {
      if (chart !== null) {
        this.chart = chart
      }
    },

    refreshList() {
      this.$refs['map'].initializeMap()
    },

    selectLocation(item) {
      this.$refs['map'].clickLocation(item)
    }
  }
}
</script>

<style scoped>
.location-list {
  height: 485px;
}

.location-map {
  height: 485px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileLocationsPage.vue